<script lang="ts">
  import { onMount } from 'svelte';
  import { navigate } from 'svelte-routing';
  import { unsubscribe as unsubscribeApi } from '$lib/utils/api';
  import Loader from '$lib/components/Loader.svelte';
  
  export let code: string = '';
  
  let loading = true;
  
  onMount(async () => {
    const result = await unsubscribeApi(code);
    navigate(result.success ? '/unsubscribed' : '/unsubscribefailed');
    loading = false;
  });
</script>

<svelte:head>
  <title>Unsubscribing... - outlive.it</title>
</svelte:head>

<section id="main" class="main">
  {#if loading}
    <Loader text="Processing your request..." />
  {/if}
</section>

<style>
  #main {
    padding: 4em;
    background-color: #ffffff;
    border-radius: 4px;
    text-align: center;
  }
</style>
